import { AccountApplicationUrlConstant } from 'src/constants';
import {
  GetAccountApplicationDto,
  AccountApplicationDocumentDto,
  AccountApplicationDto,
  UpdateAccountApplicationDocumentDto,
  UploadAccountApplicationDocumentDto,
  DownloadAccountApplicationDocumentDto,
  DownloadAccountApplicationDocumentResponseDto,
  DeleteAccountApplicationDocumentDto,
  UpdateAccountApplicationDto,
} from 'src/dtos';
import { ConfigService } from 'src/services';
import { httpRequest, replacePlaceholders } from 'src/utils';

export class AccountApplicationApi {
  private _configService: ConfigService;
  constructor(configService: ConfigService) {
    this._configService = configService;
  }

  async retrieve({ params }: GetAccountApplicationDto): Promise<AccountApplicationDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.RETRIEVE, params);

    return httpRequest<AccountApplicationDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });
  }

  async update({ params, body }: UpdateAccountApplicationDto): Promise<AccountApplicationDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.UPDATE, params);

    return httpRequest<AccountApplicationDto>({
      method: 'PUT',
      url,
      body,
      authToken: this._configService.authToken,
    });
  }

  async uploadDocument({
    params,
    body,
    onProgress,
  }: UploadAccountApplicationDocumentDto & {
    onProgress?: (percent: number) => void;
  }): Promise<AccountApplicationDocumentDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.UPLOAD_DOCUMENT, params);

    return httpRequest<AccountApplicationDocumentDto>({
      method: 'POST',
      headers: {
        contentType: 'multipart/form-data',
      },
      url,
      body,
      authToken: this._configService.authToken,
      onUploadProgress: onProgress,
    });
  }

  async downloadDocument({ params }: DownloadAccountApplicationDocumentDto): Promise<Blob> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.DOWNLOAD_DOCUMENT, params);

    const result = await httpRequest<DownloadAccountApplicationDocumentResponseDto>({
      method: 'GET',
      url,
      authToken: this._configService.authToken,
    });

    return httpRequest<Blob>({
      method: 'GET',
      url: result.downloadUrl,
      responseType: 'blob',
    });
  }

  async updateDocument({
    params,
    body,
    onProgress,
  }: UpdateAccountApplicationDocumentDto & {
    onProgress?: (percent: number) => void;
  }): Promise<AccountApplicationDocumentDto> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.UPDATE_DOCUMENT, params);

    return httpRequest<AccountApplicationDocumentDto>({
      method: 'PUT',
      headers: {
        contentType: 'multipart/form-data',
      },
      url,
      body,
      authToken: this._configService.authToken,
      onUploadProgress: onProgress,
    });
  }

  async deleteDocument({ params }: DeleteAccountApplicationDocumentDto): Promise<void> {
    const url = replacePlaceholders(AccountApplicationUrlConstant.DELETE_DOCUMENT, params);

    return httpRequest<void>({
      method: 'DELETE',
      url,
      authToken: this._configService.authToken,
    });
  }
}
